import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Box, spacing } from "@mui/system";

import {
  Avatar,
  BottomNavigation,
  BottomNavigationAction,
  Breadcrumbs as MuiBreadcrumbs,
  Button as MuiButton,
  Card as MuiCard,
  CardContent,
  Checkbox,
  CircularProgress,
  Divider as MuiDivider,
  FormControl as MuiFormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputLabel,
  Link,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField as MuiTextField,
  Typography,
  TextField,
  FormControl,
  NativeSelect,
  Input,
  Button,
} from "@mui/material";
import useAuth from "../../../hooks/useAuth";

function NotaFiscalDadosFiscais({ nfConfiguration, loadConfig,setIsDirtyData }) {
  let {
    getApi,
    postApi,
    putApi,
    user,
    signUpStep2,
    isBSAccount,
    isInitializedBS,
  } = useAuth();

  const [issueStatus, setIssueStatus] = React.useState(1);
  let [saving, setSaving] = useState(false);

  const [inscricao_municipal, setInscricao_municipal] = React.useState("");
  const [categoriaSimplesNacId, setCategoriaSimplesNacId] = React.useState(1);
  const [regimeSimplesNacionalId, setRegimeSimplesNacionalId] =
    React.useState(1);

  const [regimeEspecTribtId, setRegimeEspecTribtId] = React.useState(1);
  const [incentivoFiscal, setIncentivoFiscal] = React.useState(0);

  const [categoriasSimplesNac, setCategoriasSimplesNac] = React.useState([]);
  const [tipoRegimeSimplesNac, setTipoRegimeSimplesNac] = React.useState([]);
  const [regimesEspeciaisTribut, setregimeEspeciaisTribut] = React.useState([]);

  const loadRegimeEspecialTribut = async () => {
    let response = await getApi("/nf/regimesEspecialTribut");
    setregimeEspeciaisTribut(response.lista);
  };

  const loadCategoriaSimplesNac = async () => {
    let response = await getApi("/nf/categoriasSimplesNacional");
    setCategoriasSimplesNac(response.lista);
  };

  const loadTipoRegimeSimplesNac = async () => {
    let response = await getApi("/nf/regimesSimplesNacional");
    setTipoRegimeSimplesNac(response.lista);
  };

  useEffect(() => {
    loadCategoriaSimplesNac();
    loadTipoRegimeSimplesNac();
    loadRegimeEspecialTribut();
    if (nfConfiguration) {
      if (nfConfiguration.nfs) {
        
        setCategoriaSimplesNacId(nfConfiguration.nfs.category_simples_nac.id);
        setRegimeSimplesNacionalId(nfConfiguration.nfs.regime_simples_nac.id);
        setRegimeEspecTribtId(nfConfiguration.nfs.regime_especial_trib.id);
        setInscricao_municipal(nfConfiguration.nfs.inscricao_municipal);
      }
    }
  }, []);


  useEffect(() => {
      if (
        inscricao_municipal !== nfConfiguration.nfs.inscricao_municipal ||
        categoriaSimplesNacId !== nfConfiguration.nfs.category_simples_nac.id ||
        regimeSimplesNacionalId !== nfConfiguration.nfs.regime_simples_nac.id ||
        regimeEspecTribtId !== nfConfiguration.nfs.regime_especial_trib.id
      ) {
        setIsDirtyData(true);
      } else {
        setIsDirtyData(false);
      }
    }, [
      inscricao_municipal,
      categoriaSimplesNacId,
      regimeSimplesNacionalId,
      regimeEspecTribtId,
      nfConfiguration.nfs,
    ]);

  const saveNfsTaxsData = async () => {
    setSaving(true)
    let response = await putApi("/nf/configuration", {
      nfs: {
        tax_data: {
          categoriaSimplesNacId: categoriaSimplesNacId,
          regimeSimplesNacionalId: regimeSimplesNacionalId,
          regimeEspecTribtId: regimeEspecTribtId,
          inscricao_municipal: inscricao_municipal,
        },
      },
    });
    loadConfig();
    setSaving(false)
    alert("Dados salvos");

  };

  return (
    <React.Fragment>
      <Grid container>
        <Grid sm={12} md={4}>
          <Grid
            item
            style={{
              paddingTop: 16,
            }}
          >
            <FormControl fullWidth>
              <FormLabel
                id="linscricaomunicipallbl"
                sx={{ fontWeight: "bold" }}
              >
                Inscrição Municipal
              </FormLabel>

              <TextField
                value={inscricao_municipal}
                onChange={(e) => setInscricao_municipal(e.target.value)}
                required
                aria-labelledby="linscricaomunicipallbl"
              />
            </FormControl>
          </Grid>

          <Grid
            item
            style={{
              paddingTop: 16,
            }}
          >
            <FormControl fullWidth>
              <FormLabel
                id="lbl-situacaosimplesnacional"
                sx={{ fontWeight: "bold" }}
              >
                Situação Simples Nacional
              </FormLabel>
              <RadioGroup
                onChange={(e) => setCategoriaSimplesNacId(e.target.value)}
                value={categoriaSimplesNacId}
                sx={{ marginLeft: 1 }}
                row
                aria-labelledby="lbl-situacaosimplesnacional"
              >
                {categoriasSimplesNac.map((el) => (
                  <FormControlLabel
                    key={el.id}
                    value={el.id}
                    control={<Radio />}
                    disabled={
                      (nfConfiguration.tax_mei==true && el.id!=1) || // se for MEI
                      (nfConfiguration.tax_mei==false && el.id==3) || // se não for MEI
                      (nfConfiguration.tax_mei==false && nfConfiguration.tax_simples_nac==false && el.id==3) // se não for Simples
                      
                      }
                    label={el.name}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Grid>

          {categoriaSimplesNacId == 2 && (
            <Grid
              item
              style={{
                paddingTop: 16,
              }}
            >
              <FormControl fullWidth>
                <FormLabel id="demo-row-radio-buttons-group-label">
                  Regime de Apuração Simples Nacional
                </FormLabel>

                <Select
                  labelId="lbl-ambiente"
                  label="Tributos federais e municipais pelo SN"
                  onChange={(e) => setRegimeSimplesNacionalId(e.target.value)}
                  value={regimeSimplesNacionalId}
                >
                  {tipoRegimeSimplesNac.map((el) => (
                    <MenuItem key={el.id} value={el.id}>
                      {el.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}
          <Grid
            item
            style={{
              paddingTop: 16,
            }}
          >
            <FormControl fullWidth>
              <FormLabel id="lbl-ambiente" sx={{ fontWeight: "bold" }}>
                Regime Especial de Tributação
              </FormLabel>

              <Select
                labelId="lbl-ambiente"
                label="Ambiente"
                onChange={(e) => setRegimeEspecTribtId(e.target.value)}
                value={regimeEspecTribtId}
              >
                {regimesEspeciaisTribut.map((el) => (
                  <MenuItem key={el.id} value={el.id}>
                    {el.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* <Grid item
                style={{ 
                  paddingTop:16,
              }}>
                
                  <FormControl fullWidth>
                    <FormLabel id="lbl-incetivofiscal">Possui incentivo Fiscal</FormLabel>
                    <RadioGroup
                    sx={{marginLeft:1}}
                    onChange={e=> setIncentivoFiscal(e.target.value)}
                    value={incentivoFiscal}
                      row
                    >
                      <FormControlLabel value="0" control={<Radio />} label="Não possuo." />
                      <FormControlLabel value="1" control={<Radio />} label="Sim, possuo." />
                    
                    </RadioGroup>


                  </FormControl>
              </Grid> */}
        </Grid>
      </Grid>
      <Grid container justifyContent="flex-start" >
              <Grid item>
              {saving &&
              <Box sx={{ display: 'flex' }}>
                <CircularProgress />
              </Box>}
              </Grid>
            </Grid> 
      <br />
      <Button
        variant="contained"
        color="primary"
        mt={3}
        onClick={(e) => saveNfsTaxsData()}
        disabled={saving}
      >
        Atualizar Dados
      </Button>
    </React.Fragment>
  );
}

export default NotaFiscalDadosFiscais;
